<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t(`driver_onboarding.profile.relative.relative_${index+1}`) }}</p>
        <button class="delete" aria-label="close" @click="onClose"></button>
      </header>

      <section class="modal-card-body">
        <p class="modal-note">
          {{$t('driver_onboarding.profile.relative.description')}}
        </p>
        <div class="form-field">
          <div class="field">
            <InputField
              type="text"
              :name="`partnerName_${index}`"
              :labelName="$t('driver_onboarding.profile.general.fullname')"
              @onChange="onChangeName"
              :errorMessage="isValidName.message"
              :showError="isValidName.value === false"
              :initValue="name"
            />
          </div>

          <div class="columns">
            <div class="field column reset-pr">
              <b-select
                :placeholder="$t('driver_onboarding.profile.relative.relative')"
                class="field-relationship"
                v-model="relationship"
                @input="onChangeRelationship"
              >
                <option v-for="option in relationships" :value="option" :key="option">{{ option }}</option>
              </b-select>
            </div>

            <div class="field column">
              <InputField
                type="text"
                name="YOB"
                maxlength="4"
                :labelName="$t('driver_onboarding.profile.relative.year_of_birth')"
                @onChange="onChangeYearOfBirth"
                :errorMessage="isValidYearOfBirth.message"
                :showError="isValidYearOfBirth.value === false"
                :initValue="year_of_birth"
              />
            </div>
          </div>
          <div class="field">
            <InputField
              type="text"
              :name="`partnerMobile_${index}`"
              :labelName="$t('driver_onboarding.profile.relative.phone')"
              @onChange="onChangePhone"
              :errorMessage="isValidPhone.message"
              :showError="isValidPhone.value === false"
              :initValue="phone"
            />
          </div>
          <div class="field">
            <b-select v-model="occupation" :placeholder="$t('driver_onboarding.profile.relative.occupation')" class="field-job"
              @input="onChangeOccupation">
              <option v-for="option in jobs" :value="option" :key="option">
                {{option}}
              </option>
            </b-select>
          </div>
        </div>
        <p
          class="message-error"
          v-if="!submitButtonEnable"
        >{{$t('driver_onboarding.profile.relative.note_modal')}}</p>
        <b-button :disabled="!submitButtonEnable" class="submit-modal" @click="submit">Lưu</b-button>
      </section>
    </div>
  </div>
</template>
<script>
import InputField from "@/components/InputField";
import {mapGetters} from "vuex"

const RELATIONSHIP = {
  FATHER: "Bố",
  MOTHER: "Mẹ",
  BROTHER: "Anh/Chị/Em",
  SPOUSE: "Vợ/Chồng",
  CHILD: "Con",
  FAMILY_RELATION: "Cô/Dì/Chú/Bác"
};

const CURRENT_JOB = {
  FREEDOM: "Tự do",
  RETIRE: "Đã về hưu",
  OFFICE: "Văn phòng",
  STUDENT: "Sinh viên",
  FARMER: "Nông dân",
  WORKER: "Công nhân",
  OTHER: "Khác"
};
export default {
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      name: undefined,
      relationship: undefined,
      phone: undefined,
      year_of_birth: undefined,
      occupation: undefined,

      relationships: RELATIONSHIP,
      jobs: CURRENT_JOB
    }
  },
  components: {
    InputField
  },
  computed : {
    ...mapGetters(['formData']),
    isValidName() {
      let result = {
        value: null,
        message: ''
      }
      if(this.name === undefined || this.name === null) {
        return {
          value: null,
          message: ''
        }
      }

      result.value = this.name && this.name.length > 2
      result.message = result.value
        ? ''
        : this.$t('driver_onboarding.profile.general.require_min_length')         

      return result  
    },
    isValidYearOfBirth () {
      let result = {
        value: null,
        message: ''
      }
      const value = this.year_of_birth
      if(value === undefined || value === null) {
        return {
          value: null,
          message: ''
        }
      }

      if (!value && value !== undefined) {
        result.value = false
        result.message = this.$t('driver_onboarding.profile.relative.invalid_year_of_birth')
        return result
      }

      var cleanedValue =
          typeof value === "string" ? value.trim() : value.toString();
      const pattern = /^\+\d+$|^\d+$/;
      const isNumber = pattern.test(cleanedValue);
      if (!isNumber) {
        result.value = false
        result.message = this.$t('driver_onboarding.profile.relative.invalid_year_of_birth')
        return result
      }

      const maxYear = (new Date()).getFullYear() - 18
      const minYear = (new Date()).getFullYear() - 100
      if (cleanedValue > maxYear || cleanedValue < minYear) {
        result.value = false
        result.message = this.$t('driver_onboarding.profile.relative.require_max_year')
        return result
      }

      return {
        value: true,
        message: ''
      }
    },
    isValidPhone () {
      let result = {
        value: false,
        message: ''
      }
      const value = this.phone
      if(value === undefined || value === null) {
        return {
          value: null,
          message: ''
        }
      }

      if (!value && value !== undefined) {
        result.message = this.$t('driver_onboarding.profile.relative.invalid_phone')
        return result
      }

      var cleanedValue =
          typeof value === "string" ? value.trim() : value.toString();
      const pattern = /^\+\d+$|^\d+$/;
      const isNumber = pattern.test(cleanedValue);
      if (!isNumber) {
        result.message = this.$t('driver_onboarding.profile.relative.invalid_phone')
        return result
      }

      if (!(
          ( (cleanedValue.charAt(0) === "+" && cleanedValue.length > 5) 
            || (cleanedValue.charAt(0) !== "+" && cleanedValue.length > 4)) 
          && cleanedValue.length < 14)) {
        result.message = this.$t('driver_onboarding.profile.relative.invalid_phone')
        return result
      }

      return {
        value: true,
        message: ''
      }
    },
    submitButtonEnable () {
      return this.isValidName.value && this.isValidYearOfBirth.value && this.isValidPhone.value && this.relationship && this.occupation
    }
  },
  methods: {    
    onChangeName(value) {
      this.name = value
    },
    onChangeRelationship() {
    },
    onChangePhone (value) {
      this.phone = value
    },
    onChangeYearOfBirth(value) {
      this.year_of_birth = value
    },
    onChangeOccupation(value) {
      this.occupation = value;
    },
    onClose() {
      this.$emit('close')      
    },
    submit() {
      let relatives = [...this.formData.relatives]

      const { name, relationship, year_of_birth, phone, occupation } = this

      relatives.splice(this.index, 1, {
        name, 
        relationship, 
        year_of_birth, 
        phone, 
        occupation
      })
      this.$store.dispatch('setRelativeProfile', relatives).then(() => {
        this.onClose()
        this.$emit("submit", this.index, relatives)
      })
    }    
  },
  created() {
    if(this.data){
      for (let key in this.data) {
        this[key] = this.data[key]
      }   
    }
  }
};
</script>
<style lang="scss">
.content-form {
  .modal-card {
    max-width: 380px;

    .modal-card-head {
      border-bottom: 0;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      background-color: #fff;

      p {
        font-size: 20px;
        color: #1a1a1a;
        font-weight: 500;
        margin-bottom: 0;
      }
    }

    .modal-card-body {
      padding: 0 20px 20px;
      p.modal-note {
        font-size: 13px;
        color: #7a8189;
        margin-bottom: 20px !important;
      }

      .form-field {
        .field-relationship,
        .field-job {
          .select {
            width: 100%;
            select {
              width: 100%;
              height: 46px;
              border: none;
              background: #f2f2f2;
              color: #7a8189;
              padding: 0 12px;
              font-size: 14px;

              &:focus {
                outline: none;
                border: none;
              }
            }
          }
        }
        .column.reset-pr {
          padding-right: 0;
        }
      }
      .message-error {
        font-size: 14px;
        color: #ff3b30;
        margin: 25px 0 0 0;
      }
      .select:not(.is-multiple):not(.is-loading)::after {
        top: 1.5rem;
        border-color: #7a8189;
      }

      .submit-modal {
        width: 100%;
        height: 46px;
        border: none;
        background: #ff8200;
        color: white;
        margin-top: 23px;
      }
    }
  }
}
</style>
